// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Risks wizard — branded shell on top of .incyia-modal-* */

.import-risks-wizard-paper {
  max-width: 720px !important;
  width: 100%;
  max-height: 90vh;
  display: flex !important;
  flex-direction: column;
  background: #fff !important;
}

.import-risks-wizard-paper .incyia-modal-head {
  flex-shrink: 0;
  padding-bottom: 12px;
}

.import-risks-wizard-paper .incyia-modal-icon {
  background: #e1f4f0;
  color: #076b5c;
}

.import-risks-wizard-stepper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0 22px 4px;
  padding: 10px 12px;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  background: #f7fafa;
  flex-shrink: 0;
}

.import-risks-wizard-step {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 4px 6px;
  border-radius: 8px;
}

.import-risks-wizard-step-index {
  flex: none;
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: #eef2f7;
  color: #8a9ba7;
  border: 1px solid #dfe7e8;
}

.import-risks-wizard-step.is-active .import-risks-wizard-step-index {
  background: #00146d;
  border-color: #00146d;
  color: #fff;
}

.import-risks-wizard-step.is-done .import-risks-wizard-step-index {
  background: #e1f4f0;
  border-color: #c5e4dc;
  color: #076b5c;
}

.import-risks-wizard-step-meta {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.import-risks-wizard-step.is-active .import-risks-wizard-step-meta {
  color: #0d9b87;
}

.import-risks-wizard-step-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #5f7484;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.import-risks-wizard-step.is-active .import-risks-wizard-step-title,
.import-risks-wizard-step.is-done .import-risks-wizard-step-title {
  color: #0b1e2d;
}

.import-risks-wizard-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 14px 22px 8px;
}

.import-risks-wizard-hint {
  margin: 0 0 12px;
  font-size: 13.5px;
  line-height: 1.45;
  color: #5f7484;
}

.import-risks-wizard-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: min(46vh, 380px);
  overflow: auto;
  padding-right: 4px;
}

.import-risks-wizard-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 12px 14px;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
}

.import-risks-wizard-row.is-readonly {
  grid-template-columns: minmax(0, 1fr);
}

.import-risks-wizard-row input[type='checkbox'] {
  margin-top: 3px;
  width: 16px;
  height: 16px;
  accent-color: #0d9b87;
  cursor: pointer;
}

.import-risks-wizard-row input[type='checkbox']:disabled {
  cursor: default;
  opacity: 0.7;
}

.import-risks-wizard-row-title {
  margin: 0;
  font-size: 14.5px;
  font-weight: 700;
  color: #0b1e2d;
  line-height: 1.35;
  word-break: break-word;
}

.import-risks-wizard-row-desc {
  margin: 4px 0 8px;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.import-risks-wizard-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.import-risks-wizard-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 99px;
  border: 1px solid #dfe7e8;
  background: #f7fafa;
  font-size: 11.5px;
  font-weight: 700;
  color: #5f7484;
}

.import-risks-wizard-empty {
  padding: 28px 16px;
  text-align: center;
  color: #8a9ba7;
  font-size: 13.5px;
  border: 1px dashed #dfe7e8;
  border-radius: 10px;
  background: #f7fafa;
}

.import-risks-wizard-section-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  color: #0b1e2d;
}

.import-risks-wizard-link-btn {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0 0 10px;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #076b5c;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.import-risks-wizard-link-btn:hover {
  color: #055447;
}

.import-risks-wizard-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.import-risks-wizard-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.import-risks-wizard-field label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.import-risks-wizard-field input,
.import-risks-wizard-field textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  background: #fff;
  padding: 9px 12px;
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: #0b1e2d;
  outline: none;
}

.import-risks-wizard-field input:focus,
.import-risks-wizard-field textarea:focus {
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.15);
}

.import-risks-wizard-field.is-error input {
  border-color: #d14a3e;
}

.import-risks-wizard-field-error {
  margin: 0;
  font-size: 12px;
  color: #d14a3e;
}

.import-risks-wizard-field-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.import-risks-wizard-manual-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 180px;
  overflow: auto;
}

.import-risks-wizard-manual-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  background: #fff;
}

.import-risks-wizard-remove {
  appearance: none;
  border: none;
  background: none;
  padding: 2px 6px;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #d14a3e;
  cursor: pointer;
}

.import-risks-wizard-remove:hover {
  text-decoration: underline;
}

.import-risks-wizard-warning {
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #f0d9a8;
  background: #fff8eb;
  color: #84540a;
  font-size: 13px;
  line-height: 1.4;
}

.import-risks-wizard-foot {
  flex-shrink: 0;
  padding: 12px 22px 16px;
  background: #f7fafa;
  border-top: 1px solid #dfe7e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.import-risks-wizard-foot-meta {
  font-size: 12.5px;
  font-weight: 600;
  color: #5f7484;
}

.import-risks-wizard-foot-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
}

/* Detecting overlay */
.import-risks-detect-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  background: rgba(6, 21, 36, 0.55);
  font-family: Lato, sans-serif;
}

.import-risks-detect-card {
  width: min(360px, calc(100vw - 32px));
  padding: 28px 24px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dfe7e8;
  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.4);
  text-align: center;
}

.import-risks-detect-spinner {
  width: 28px;
  height: 28px;
  margin: 0 auto 12px;
  border-radius: 50%;
  border: 2.5px solid #dfe7e8;
  border-top-color: #0d9b87;
  animation: import-risks-spin 0.7s linear infinite;
}

.import-risks-detect-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
}

.import-risks-detect-hint {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.45;
  color: #5f7484;
}

@keyframes import-risks-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 720px) {
  .import-risks-wizard-stepper {
    grid-template-columns: 1fr;
  }

  .import-risks-wizard-field-row {
    grid-template-columns: 1fr;
  }

  .import-risks-wizard-step-title {
    white-space: normal;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/plan/ImportRisksWizard.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Import Risks wizard — branded shell on top of .incyia-modal-* */\n\n.import-risks-wizard-paper {\n  max-width: 720px !important;\n  width: 100%;\n  max-height: 90vh;\n  display: flex !important;\n  flex-direction: column;\n  background: #fff !important;\n}\n\n.import-risks-wizard-paper .incyia-modal-head {\n  flex-shrink: 0;\n  padding-bottom: 12px;\n}\n\n.import-risks-wizard-paper .incyia-modal-icon {\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.import-risks-wizard-stepper {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0 22px 4px;\n  padding: 10px 12px;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  background: #f7fafa;\n  flex-shrink: 0;\n}\n\n.import-risks-wizard-step {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 4px 6px;\n  border-radius: 8px;\n}\n\n.import-risks-wizard-step-index {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: #eef2f7;\n  color: #8a9ba7;\n  border: 1px solid #dfe7e8;\n}\n\n.import-risks-wizard-step.is-active .import-risks-wizard-step-index {\n  background: #00146d;\n  border-color: #00146d;\n  color: #fff;\n}\n\n.import-risks-wizard-step.is-done .import-risks-wizard-step-index {\n  background: #e1f4f0;\n  border-color: #c5e4dc;\n  color: #076b5c;\n}\n\n.import-risks-wizard-step-meta {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.import-risks-wizard-step.is-active .import-risks-wizard-step-meta {\n  color: #0d9b87;\n}\n\n.import-risks-wizard-step-title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #5f7484;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.import-risks-wizard-step.is-active .import-risks-wizard-step-title,\n.import-risks-wizard-step.is-done .import-risks-wizard-step-title {\n  color: #0b1e2d;\n}\n\n.import-risks-wizard-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 14px 22px 8px;\n}\n\n.import-risks-wizard-hint {\n  margin: 0 0 12px;\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.import-risks-wizard-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: min(46vh, 380px);\n  overflow: auto;\n  padding-right: 4px;\n}\n\n.import-risks-wizard-row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n  padding: 12px 14px;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.import-risks-wizard-row.is-readonly {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.import-risks-wizard-row input[type='checkbox'] {\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  accent-color: #0d9b87;\n  cursor: pointer;\n}\n\n.import-risks-wizard-row input[type='checkbox']:disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.import-risks-wizard-row-title {\n  margin: 0;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.import-risks-wizard-row-desc {\n  margin: 4px 0 8px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.import-risks-wizard-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.import-risks-wizard-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 99px;\n  border: 1px solid #dfe7e8;\n  background: #f7fafa;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #5f7484;\n}\n\n.import-risks-wizard-empty {\n  padding: 28px 16px;\n  text-align: center;\n  color: #8a9ba7;\n  font-size: 13.5px;\n  border: 1px dashed #dfe7e8;\n  border-radius: 10px;\n  background: #f7fafa;\n}\n\n.import-risks-wizard-section-title {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.import-risks-wizard-link-btn {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0 0 10px;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  color: #076b5c;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.import-risks-wizard-link-btn:hover {\n  color: #055447;\n}\n\n.import-risks-wizard-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.import-risks-wizard-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.import-risks-wizard-field label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.import-risks-wizard-field input,\n.import-risks-wizard-field textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  background: #fff;\n  padding: 9px 12px;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  color: #0b1e2d;\n  outline: none;\n}\n\n.import-risks-wizard-field input:focus,\n.import-risks-wizard-field textarea:focus {\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.15);\n}\n\n.import-risks-wizard-field.is-error input {\n  border-color: #d14a3e;\n}\n\n.import-risks-wizard-field-error {\n  margin: 0;\n  font-size: 12px;\n  color: #d14a3e;\n}\n\n.import-risks-wizard-field-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.import-risks-wizard-manual-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 180px;\n  overflow: auto;\n}\n\n.import-risks-wizard-manual-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.import-risks-wizard-remove {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 2px 6px;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  color: #d14a3e;\n  cursor: pointer;\n}\n\n.import-risks-wizard-remove:hover {\n  text-decoration: underline;\n}\n\n.import-risks-wizard-warning {\n  margin: 12px 0 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #f0d9a8;\n  background: #fff8eb;\n  color: #84540a;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.import-risks-wizard-foot {\n  flex-shrink: 0;\n  padding: 12px 22px 16px;\n  background: #f7fafa;\n  border-top: 1px solid #dfe7e8;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.import-risks-wizard-foot-meta {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #5f7484;\n}\n\n.import-risks-wizard-foot-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-left: auto;\n}\n\n/* Detecting overlay */\n.import-risks-detect-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: grid;\n  place-items: center;\n  background: rgba(6, 21, 36, 0.55);\n  font-family: Lato, sans-serif;\n}\n\n.import-risks-detect-card {\n  width: min(360px, calc(100vw - 32px));\n  padding: 28px 24px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.4);\n  text-align: center;\n}\n\n.import-risks-detect-spinner {\n  width: 28px;\n  height: 28px;\n  margin: 0 auto 12px;\n  border-radius: 50%;\n  border: 2.5px solid #dfe7e8;\n  border-top-color: #0d9b87;\n  animation: import-risks-spin 0.7s linear infinite;\n}\n\n.import-risks-detect-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.import-risks-detect-hint {\n  margin: 6px 0 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n@keyframes import-risks-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 720px) {\n  .import-risks-wizard-stepper {\n    grid-template-columns: 1fr;\n  }\n\n  .import-risks-wizard-field-row {\n    grid-template-columns: 1fr;\n  }\n\n  .import-risks-wizard-step-title {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
